export const number = process.env.VERSION
export const commit = process.env.COMMIT
